import React from "react";

export const SystemError: React.FC = () => {
    return (
        <section className="page">
            <div
                style={{
                    height: "500px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <h2 style={{ fontSize: "24px" }}>
                    <div>画面の処理中にエラーが発生しました。</div>
                    <div>ご迷惑をおかけしております。</div>
                </h2>
            </div>
        </section>
    );
};
